<template>
    <div class="TheModeD">
        <div class="Title">
            <div>
                <p>营销活动</p>
            </div>
            <!-- <span>MARKETING ACTIVITIES</span> -->
        </div>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="20">
                <el-row type="flex" class="row-bg" justify="center">
                    <el-col
                        :span="8"
                        v-for="(item, index) in globalactivityfromlist"
                        :key="item.index"
                    >
                        <img @click="jumpPage(item)" :src="item.image" />
                        <el-col class="details bubble" :span="24">
                            <p @click="jumpPage(item)" class="suprice">
                                {{ item.title }}
                            </p>
                            <p class="small" @click="jumpPage(item)">
                                【 查看详情 】
                            </p>
                            <p class="go">
                                <span class="going">
                                    <span>{{
                                        item.startDate,
                                        item.endDate | timestate
                                    }}</span>
                                </span>
                                <span>{{ item.startDate | formatDate }}</span>
                                <i class="el-icon-minus"></i>
                                <span>{{ item.endDate | formatDate }}</span>
                            </p>
                        </el-col>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { homeActivityQuery } from "@/api/homePage";
export default {
    data() {
        return {
            globalactivityfromlist: []
        };
    },
    created() {
        this.activityquery();
    },
    methods: {
        activityquery() {
            homeActivityQuery()
                .then(res => {
                    if (res.status === 2000) {
                        this.globalactivityfromlist = res.data;
                    }
                })
                .catch(err => {});
        },
        //新闻跳转
        jumpPage(item) {
            this.$router.push({
                path: item.demoFlag,
                query: {
                    id: item.menuId,
                    contentid: item.articleId
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.TheModeD {
    padding-bottom: 200px;
    background-color: #f5f6f7;
    .Title {
        text-align: center;
        padding-top: 80px;
        padding-bottom: 60px;
        p {
            display: inline-block;
            margin: 0;
            font-size: 24px;
        }
        span {
            display: inline-block;
            margin-top: 8px;
            font-size: 11px;
            color: #666;
        }
    }
    .el-row {
        .el-col:nth-child(2) {
            margin: 0 10px;
        }
        .el-col {
            position: relative;
            img {
                cursor: pointer;
                width: 100%;
            }
            .details {
                position: absolute;
                bottom: -138px;
                right: -10px;
                height: 141px;
                background-color: #fff;
                overflow: hidden;
                p {
                    margin-left: 40px;
                }
                .suprice {
                    cursor: pointer;
                    z-index: 99;
                    margin-top: 30px;
                    font-size: 18px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .small {
                    z-index: 99;
                    margin-left: 32px;
                    cursor: pointer;
                    font-size: 14px;
                    color: #fabe00;
                    margin-top: 15px;
                }
                .go {
                    z-index: 99;
                    margin-top: 15px;
                    font-size: 14px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #666;
                    .going {
                        color: #fa7c00;
                        margin-right: 20px;
                    }
                }
            }
            // .bubble:after {
            //     content: "";
            //     background-color: #fff;
            //     position: absolute;
            //     width: 100%;
            //     height: 100%;
            //     top: 0;
            //     left: 0;
            //     // opacity: 0;
            //     margin: auto;
            //     // transition: all 0.5s ease-in-out;
            // }
            .bubble:hover:after {
                display: none;
                // transition: all 0.5s ease-in-out;
            }
            .bubble::before {
                content: "";
                background-color: #fabe00;
                position: absolute;
                width: 600px;
                height: 600px;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                opacity: 0;
                margin: auto;
                transform: scale(0);
                opacity: 1;
                transition: 0s;
                border-radius: 50%;
                transition: all 0.5s ease-in-out;
                z-index: 1;
            }
            .bubble:hover:before {
                z-index: 1;
                border-radius: 50%;
                transform: scale(1.5);
                transition: all 0.5s ease-in-out;
                opacity: 1;
                z-index: 5;
            }
            .details:hover p {
                color: #fff;
                position: relative;
                z-index: 99;
                .going {
                    color: #fff;
                }
            }
        }
    }
}
</style>
